import { useMerchant } from "@/hooks/useMerchant";
import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

export function useFetchPayout(payoutId: string | null) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const { data, isLoading, refetch } = useQuery(
    trpc.payouts.get.queryOptions(
      {
        rentalsMerchantId: merchant?.id ?? "",
        id: payoutId ?? "",
      },
      {
        enabled: !!merchant?.id && !!payoutId,
      }
    )
  );

  return {
    payout: data,
    isLoadingPayout: isLoading,
    refetchPayout: refetch,
  };
}
